/* eslint-disable react/require-default-props */
import React from 'react';
import AiManagementStatCard from 'components/atoms/ai_management_stat_card';
import AiManagementSummaryCard from 'components/atoms/ai_management_summary_card';
import AiManagementCollapsibleCard from 'components/molecules/ai_management_collapsible_card';
import AiManagementCompetitorReasons from 'components/molecules/ai_management_competitor_reasons';
import { PossibleCompetitorQualification } from 'services/actions/ai_management_possible_competitors';
import { count } from 'services/ai_management_format';

interface AiManagementCompetitorQualificationProps {
  qualification: PossibleCompetitorQualification;
  className?: string;
}

const AiManagementCompetitorQualification: React.FC<AiManagementCompetitorQualificationProps> = ({
  qualification,
  className = '',
}) => (
  <AiManagementCollapsibleCard title="Habilitação" className={className}>
    {qualification.texto ? (
      <AiManagementSummaryCard className="mb-3">{qualification.texto}</AiManagementSummaryCard>
    ) : null}

    <div className="row mb-3">
      <div className="col-sm-6 mb-3 mb-sm-0">
        <AiManagementStatCard
          value={count(qualification.desclassificados)}
          label="Itens desclassificados"
        />
      </div>
      <div className="col-sm-6">
        <AiManagementStatCard
          value={count(qualification.inabilitados)}
          label="Itens inabilitados"
        />
      </div>
    </div>

    <AiManagementCompetitorReasons
      title="Motivos de desclassificação"
      reasons={qualification.desclassificadas}
      className="mb-3"
    />
    <AiManagementCompetitorReasons
      title="Motivos de inabilitação"
      reasons={qualification.inabilitadas}
    />
  </AiManagementCollapsibleCard>
);

export default AiManagementCompetitorQualification;
